<mat-form-field>
   <input
      matInput
      type="text"
      [formControl]="formCtrl"
      [placeholder]="placeholder"
      [matAutocomplete]="auto"
      (focus)="onFocus()"
      autocomplete="off"
   />
   <span *ngIf="selected" class="clear-selection" (click)="clear()">
      <mat-icon>close</mat-icon>
   </span>
   <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="onOptionSelect($event)"
   >
      <ng-container *ngIf="(priorityTasks$ | async).length > 0">
         <mat-optgroup [label]="priorityTasksLabel" *ngIf="(filteredPriority$ | async)?.length > 0">
            <mat-option *ngFor="let task of filteredPriority$ | async" [value]="task">
               {{ task.name }}
            </mat-option>
         </mat-optgroup>
         <mat-optgroup label="All Tasks">
            <mat-option *ngFor="let task of filtered$ | async" [value]="task">
               {{ task.name }}
            </mat-option>
         </mat-optgroup>
      </ng-container>
      <ng-container *ngIf="(priorityTasks$ | async).length === 0">
         <mat-option *ngFor="let task of filtered$ | async" [value]="task">
            {{ task.name }}
         </mat-option>
      </ng-container>
   </mat-autocomplete>
</mat-form-field>
